<template>
    <div class="space-y-4">
        <div class="font-semibold text-base">
            {{ addOn.label }}
            <span v-if="isPayAtLocation">*</span>
        </div>

        <AddOnChildren :children="addOn.children" />

        <RadioButtonGroup :name="addOn.id" v-model="internalValue" class="border border-slate-200 rounded-xl divide-y divide-slate-200">
            <RadioButton class="px-4 py-3" value="__none__">{{ $t('No') }} {{ addOn.label }}</RadioButton>

            <RadioButton class="px-4 py-3" v-for="opt in addOn.options" :key="opt.id" :value="String(opt.id)">
                <span class="flex-1 flex justify-between">
                    <span>{{ opt.label }}</span>
                    <span class="text-sm text-gray-600">
                        {{ $n(opt.price, 'currency') }}
                    </span>
                </span>
            </RadioButton>
        </RadioButtonGroup>
    </div>
</template>

<script setup>
import AddOnChildren from './AddOnChildren.vue'

const props = defineProps({
    addOn: { type: Object, required: true },
    value: {
        type: [String, Number, null],
        default: null
    },
    onChange: {
        type: Function,
        required: false
    }
})

const isPayAtLocation = computed(() => props.addOn?.payAtLocation || props.addOn?.pay_at_location)

const internalValue = computed({
    get() {
        return props.value == null ? '__none__' : String(props.value)
    },
    set(v) {
        props.onChange?.(v === '__none__' ? null : v)
    }
})
</script>
